import { hasDataPrivacyConsentRead } from 'FormsUI/selectors/Scope';
import { isUngatedForAdConsentProperties } from 'FormsUI/selectors/Gates';
export const hasAdConsentAccess = state => hasDataPrivacyConsentRead(state) && isUngatedForAdConsentProperties(state);